import React, { Component } from 'react';
import { ButtonGroup, Button, Card, CardBody, CardHeader, Col, Row, Table } from 'reactstrap';
import TablePaginator from '../../containers/TablePaginator/TablePaginator';
import ListActions from '../../containers/ListActions/ListActions';
import { connect } from 'react-redux';
import { fetchObjs, deleteObj, download } from '../../actions';
import { emptyMessage } from '../../utils/utils';
import DownloadActions from '../../containers/DownloadActions/DownloadActions';

class MetaList extends Component {

    state = {
        url: '/metas'
    }

    componentDidMount() {
        this.props.fetchObjs(this.state.url);
    }

    render() {
        return (
            <div className="animated fadeIn">
                <Row>
                    <Col>
                        <Card>
                            <CardHeader>
                                <Row>
                                    <Col xs="6" sm="6">
                                        <strong>Investimentos</strong>
                                    </Col>
                                    <Col xs="6" sm="6" style={{ textAlign: 'right' }}>
                                        <ButtonGroup>
                                            <Button type="button" size="sm" color="primary" onClick={() => this.props.history.push(`${this.state.url}/new`)}>
                                                <i className="fa fa-plus"></i> Novo
                                        </Button>
                                            <DownloadActions body={this.props.metas.length !== 0 ? this.props.metas : null} />
                                        </ButtonGroup>
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                {this.props.metas.length === 0 ? emptyMessage : ([
                                    <Table key="table" hover bordered striped responsive size="sm">
                                        <thead key="thead" >
                                            <tr key="head">
                                                <th key="id">Código</th>
                                                <th key="descricao">Descrição</th>
                                                <th key="resp">Responsável</th>
                                                <th key="status">Status</th>
                                                <th xs="12" sm="1" key="acoes" className="text-center">Ações</th>
                                            </tr>
                                        </thead>
                                        <tbody key="tbody" >
                                            {this.props.metas.map((meta, i) => {
                                                return (
                                                    <tr key={`tr${i}`} >
                                                        <td key={`id${i}`} onClick={() => this.props.history.push(`${this.state.url}/${meta.ID}`)}>{meta ? meta.ID : ''}</td>
                                                        <td key={`descricao${i}`} onClick={() => this.props.history.push(`${this.state.url}/${meta.ID}`)}>{meta ? meta.DESCRICAO : ''}</td>
                                                        <td key={`resp${i}`} onClick={() => this.props.history.push(`${this.state.url}/${meta.ID}`)}>{meta && meta.funcionario && meta.funcionario.pessoaFisica ? meta.funcionario.pessoaFisica.pessoa.NOME : ''}</td>
                                                        <td key={`status${i}`} style={{ color: meta.status ? meta.status.COR : 'black' }} onClick={() => this.props.history.push(`${this.state.url}/${meta.ID}`)}>{meta && meta.status ? meta.status.DESCRICAO : ''}</td>
                                                        <td key={`actions${i}`}><ListActions {...this.props} {...this.state} id={meta.ID} /></td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </Table>,
                                    <TablePaginator key="paginator" {...this.props} {...this.state} />
                                ])}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        metas: state.obj.records ? state.obj.records : [],
        meta: state.obj.meta ? state.obj.meta : {}
    }
}

export default connect(mapStateToProps, { fetchObjs, deleteObj, download })(MetaList);

